module.exports = __webpack_public_path__ + "assets/img/11719a34f726f88795295a6125c3fae1.png";